// src/main.jsx
import React from 'react'
import ReactDOM from 'react-dom/client'
import StickMenu from './StickMenu.jsx'
import './stick-menu.css'

// 既存ページに埋め込む前提：bodyのdata属性からJSONパスを決めて読み込む

function resolveStickMenuJsonUrl() {
  const body = document.body
  const ds = body?.dataset || {}

  // 対象判定：data-site-id が無ければ正常終了（StickMenu作らない）
  if (!ds.siteId) return null

  // 優先順位（具体度が高いものを優先）
  // B7 > B5 > B1-4 > B0
  if (ds.modelName) {
    // b7は既にURLエンコード済みの値が入る前提のためエンコードしない（サーバーサイド側と合意済み）
    return `/assets/json/stickmenu/b7/${ds.modelName}.json`
  }

  if (ds.b5Id) {
    const b5id = encodeURIComponent(ds.b5Id)
    return `/assets/json/stickmenu/b5/${b5id}.json`
  }

  if (ds.categoryId) {
    const cat = encodeURIComponent(ds.categoryId)
    return `/assets/json/stickmenu/category/${cat}.json`
  }

  // B0（現状は固定でOK）
  return '/assets/json/stickmenu-b0.json'
}

async function fetchJson(url) {
  const res = await fetch(url, { cache: 'no-store' })

  if (!res.ok) {
    throw new Error(`Failed to fetch JSON. status=${res.status} url=${url}`)
  }

  // JSONパースエラーも catch したいのでここはtry/catch側に任せる
  return await res.json()
}

function mountStickMenu(config) {
  // visible が false の場合は生成しない（正常終了）
  if (config && config.visible === false) return

  // mount root を用意（既存サイトでは body閉じタグ直前に差し込む想定）
  let rootEl = document.getElementById('stick-menu-root')
  if (!rootEl) {
    rootEl = document.createElement('div')
    rootEl.id = 'stick-menu-root'
    document.body.appendChild(rootEl)
  }

  ReactDOM.createRoot(rootEl).render(
    <React.StrictMode>
      <StickMenu config={config || {}} />
    </React.StrictMode>
  )
}

function ensureStickMenuCssLoaded() {
  const id = 'stick-menu-css'
  if (document.getElementById(id)) return

  const link = document.createElement('link')
  link.id = id
  link.rel = 'stylesheet'
  link.href = '/assets/js/stick-menu/fy25/stick-menu.css'
  document.head.appendChild(link)
}

async function init() {
  const jsonUrl = resolveStickMenuJsonUrl()

  // 対象外：何もしない（正常終了）
  if (!jsonUrl) return

  ensureStickMenuCssLoaded()

  try {
    const config = await fetchJson(jsonUrl)
    mountStickMenu(config)
  } catch (err) {
    // 現状は仮：console.log に出すだけ（後でAPI送信に差し替え）
    console.log('[stick-menu] failed to load json:', {
      message: err?.message || String(err),
      jsonUrl,
      pageUrl: window.location.href,
      dataset: { ...document.body.dataset },
    })
  }
}

init()
